module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/text/menu-4e602d6b3859ac344c507a632a03a5cd.svg";